import React from 'react';
import styles from './Products.module.css';
import FeatureProducts from '../FeatureProducts/FeatureProducts';


export default function Products() {
  
return(

  <FeatureProducts/>
)
    
}
